// Module
var code = `<div class="svc-side-bar__container-header">
  <div class="svc-side-bar__container-actions">
    <!-- ko component: { name: 'sv-action-bar', params: { model: model.toolbar } } -->
    <!-- /ko -->
  </div>
  <!-- ko if: !!model.title -->
  <div class="svc-side-bar__container-title" data-bind="text: model.title">
  </div>
  <!-- /ko -->
</div>`;
// Exports
export default code;